import useWindowDimensions from './useWindowsDimensions'
export default useWindowDimensions
